import { prepareDocumentGraphData } from "./prepareNewSourceData";
import { processAppliedUpdates } from "./processAppliedUpdates";
import { processDeleted } from "./processDeleted";
import { prepareNodes } from "./prepareNodes";
import { prepareEdges } from "./prepareEdges";
import { prepareGroups } from "./prepareGroups";
import { mapToArray } from "Utils";
export const processSaveGraph = (data) => {
    const { prevData } = data;
    const documentGraphData = prepareDocumentGraphData(data);
    const appliedUpdates = processAppliedUpdates(data.appliedUpdates);
    const deleted = processDeleted({ documentGraphData, prevData, appliedUpdates });
    const { nodesSourceForServer, nodesForServer } = prepareNodes({
        documentGraphData,
        prevData
    });
    const { edgeSourceForServer, edgesForServer } = prepareEdges({
        documentGraphData,
        prevData
    });
    const { groupsSourceForServer, groupsForServer, currentGroups } = prepareGroups({
        documentGraphData,
        prevData,
        deletedGroupsIds: deleted.deletedGroupIds
    });
    const graphDataDiff = {
        Id: documentGraphData.Id,
        GraphModel: documentGraphData.GraphModel,
        DeletedNodeIds: deleted.deletedNodeIds,
        DeletedEdgeIds: deleted.deletedEdgeIds,
        DeletedGroupsIds: deleted.deletedGroupIds,
        NodesSource: mapToArray(nodesSourceForServer),
        EdgesSource: mapToArray(edgeSourceForServer),
        Groups: mapToArray(groupsSourceForServer),
        Nodes: mapToArray(nodesForServer),
        Edges: mapToArray(edgesForServer),
        DataGroups: mapToArray(groupsForServer),
        LayoutAlgorithm: documentGraphData.LayoutAlgorithm,
        SourceTaskApplied: Array.from(appliedUpdates.appliedSourceTaskIds)
    };
    documentGraphData.DataGroups = currentGroups;
    return {
        documentGraphData,
        graphDataDiff
    };
};
